import React, { useEffect, useRef, useState } from "react";
import BGImg from "../assets/img/background.jpg";
import wandererImg from "../assets/img/dear-wanderer.png";
import wandererImg2 from "../assets/img/dear-wanderer@2x.png";
import headerImg from "../assets/img/openmouth.png";
import headerImg2 from "../assets/img/openmouth@2x.png";
import scratchesImg from "../assets/img/scratches.png";
import scratchesImg2 from "../assets/img/scratches@2x.png";
import logoRed from "../assets/img/logo-red.png";
import logoRed2 from "../assets/img/logo-red@2x.png";
import { useLocation } from "react-router-dom";
import Comment from "./Comment";
import oddVid from "../assets/media/ODD.mp4";
import oddStill from "../assets/img/odd-still.jpg";
import playBtn from "../assets/img/play-button.svg";

function Home(props) {
  const { pathname } = useLocation();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handlePlayClick = () => {
    setIsPlaying(true);
    videoRef.current.play();
  };

  return (
    <div
      className="App"
      style={{
        backgroundImage: `url(${BGImg})`,
        backgroundPosition: "top center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Comment>{`
Smart rabbits earn treats,
Smart rabbits deserve feats,
And in the woods a lonely box,
Snatch it up before the fox.
First to hop, is first to win -
a second wasted would be a sin.
`}</Comment>
      <div className="dear-wanderer">
        <img
          className="dear-wanderer__img"
          src={wandererImg}
          srcSet={`${wandererImg} 1x, ${wandererImg2} 2x`}
          alt="dear wanderer"
        />
      </div>
      <header className="App-header">
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />

        <img
          className="App-header__img-placeholder"
          src={headerImg}
          srcSet={`${headerImg} 1x, ${headerImg2} 2x`}
          alt="Open Mouth, what's in the box?"
        />

        <img
          className="App-header__scratches"
          src={scratchesImg}
          srcSet={`${scratchesImg} 1x, ${scratchesImg2} 2x`}
          alt="scratched out eyes"
        />
      </header>
      <div className="pre-main">
        <video
          controls={true}
          onPlay={() => setIsPlaying(true)}
          ref={videoRef}
          src={oddVid}
          type="video/mp4"
        ></video>
        <img
          alt="one day die video play"
          className="play"
          hidden={isPlaying}
          onClick={handlePlayClick}
          src={playBtn}
          role="button"
        />
        <img
          alt="one day die video still"
          className="still"
          hidden={isPlaying}
          onClick={handlePlayClick}
          src={oddStill}
        />
      </div>
      <main>
        <img
          className="odd-logo"
          src={logoRed}
          srcSet={`${logoRed} 1x, ${logoRed2} 2x`}
          alt="One Day Die Logo"
        />
        {props.children}
      </main>
    </div>
  );
}

export default Home;
